<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="next30Days"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">People on safari</h2></app-cells>
      <div class="charts-grid">
        <highcharts :options="graph_people_options" />
      </div>
      <app-cells><h2 class="title">Cars</h2></app-cells>
      <div class="charts-grid">
        <highcharts :options="graph_options" />
      </div>
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import {Chart} from 'highcharts-vue'
import moment from 'moment'
import { getSafariAnalyticsGroups, getSafariAnalyticsCars } from '@/http'

export default {
  name: 'SafariGeneralAnalytics',
  components: { VueCtkDateTimePicker, highcharts: Chart },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      graph_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_people_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchGraph()
        this.fetchGraphPeople()
      })
    }, 0)
  },
  methods: {
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchGraph()
        this.fetchGraphPeople()
      } else this.date_picker_error = true
    },
    fetchGraph() {
      getSafariAnalyticsCars(this.filter_dates.start, this.filter_dates.end)
        .then(response => {
          this.graph_options.xAxis.categories = response.data.categories
          this.graph_options.series = response.data.series
        })
    },
    fetchGraphPeople() {
      getSafariAnalyticsGroups(this.filter_dates.start, this.filter_dates.end)
        .then(response => {
          this.graph_people_options.xAxis.categories = response.data.categories
          this.graph_people_options.series = response.data.series
          this.is_loaded = true
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
